export default "<h1 class=\"title\">{{httpCode}}</h1>\n<p>{{message}}</p>\n";